module.exports = __webpack_public_path__ + "img/linklogo2.5ebb81ed.png";